module.exports = __webpack_public_path__ + "img/officals_4.93196101.png";